<template>
  <div>
    <AllMockups />
    <v-card class="ps-card" flat>
      <div class="ps-card__head ps-card__head--toggle" @click="showCreate = !showCreate">
        <v-icon small>mdi-plus-box-outline</v-icon>
        Neues Mockup anlegen
        <v-spacer />
        <v-icon small>{{ showCreate ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
      </div>
      <v-expand-transition>
        <v-card-text v-show="showCreate">
          <CreateNewMockup />
        </v-card-text>
      </v-expand-transition>
    </v-card>
    <v-card class="ps-card" flat>
      <div class="ps-card__head ps-card__head--toggle" @click="showFallbacks = !showFallbacks">
        <v-icon small>mdi-backup-restore</v-icon>
        Fallback-Mockups
        <v-spacer />
        <v-icon small>{{ showFallbacks ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
      </div>
      <v-expand-transition>
        <v-card-text v-show="showFallbacks">
          <FallbackMockups />
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
import CreateNewMockup from "@/components/Settings/Mockups/CreateNewMockup";
import AllMockups from "@/components/Settings/Mockups/AllMockups";
import FallbackMockups from "@/components/Settings/Mockups/FallbackMockups";
export default {
  components: {FallbackMockups, AllMockups, CreateNewMockup},
  data() {
    return {
      showCreate: false,
      showFallbacks: false,
    };
  },
};
</script>

<style scoped></style>
